/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'filter': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M63.18 83.553c-.9 12.301.398 24.602 0 37 0 1.2 0 2.102.1 2.801 1.102-.898 2.2-1.699 3.4-2.699 3.398-2.8 6.5-6 10-8.8 2.3-1.9 4.8-3.602 7.198-5.5 1.2-1 2.5-2 3.602-3.2.398-.398.7-.8 1.102-1.2.101-6.6.101-13.198 0-19.8 0-5.602 1.601-10.898 4.398-15.2 6-9.198 11.199-18.897 17.898-27.698 1.5-2 2.7-4.102 4.3-6.102 2.7-3.3 2-5-2.198-5.601-2.102-.301-4.2-.7-6.301-.5-11 .699-22 .398-33 .8-6.899-.101-13.898-.398-20.801-.5a457.66 457.66 0 0 0-16.7 0c-2.8.102-3.698 1.5-2.898 4.2.2.699.602 1.398 1 2.101 8.7 13.398 16.301 27.5 25.898 40.398 2.301 2.902 3.2 5.902 3 9.5h.001z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
